var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "booking-widget",
      class: { error: !!_vm.errors.has(_vm.newName) }
    },
    [
      _c("functional-calendar", {
        ref: "BookingCalendar",
        attrs: { configs: _vm.calendarConfigs, name: "date_range" },
        scopedSlots: _vm._u([
          {
            key: "dateRangeInputs",
            fn: function(props) {
              return [
                _c("h2", { staticClass: "section-title-sm mb-3" }, [
                  _vm._v(_vm._s(_vm.title))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "grid grid-cols-2 gap-2" }, [
                  _c("div", [
                    _c(
                      "label",
                      {
                        staticClass: "theme-input__label",
                        attrs: { for: "check-in" }
                      },
                      [_vm._v("From")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "booking-widget__input-wrapper" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "`required`"
                            }
                          ],
                          staticClass: "booking-widget__input",
                          class: {
                            "bg-red-500": !!_vm.errors.has(_vm.newName)
                          },
                          attrs: {
                            id: "check-in",
                            type: "text",
                            title: "Start Date",
                            name: "start_date",
                            placeholder: _vm.chooseDatePlaceholder,
                            readonly: !props.isTypeable
                          },
                          domProps: {
                            value: props.startDate
                              ? _vm
                                  .moment(props.startDate, "DD/MM/YYYY")
                                  .format("DD-MM-YYYY")
                              : null
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "theme-input__extra-info" }, [
                          _c("span", { staticClass: "icon-calendar" })
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          attrs: { type: "hidden", name: "start_date" },
                          domProps: {
                            value: _vm
                              .moment(props.startDate, "DD/MM/YYYY")
                              .format("YYYY-MM-DD")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _vm.errors.has(_vm.newName)
                      ? _c("div", { staticClass: "theme-input__error-text" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.errors.first(_vm.newName)) +
                              "\n          "
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "label",
                      {
                        staticClass: "theme-input__label",
                        attrs: { for: "check-in" }
                      },
                      [_vm._v("To")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "booking-widget__input-wrapper" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "`required`"
                            }
                          ],
                          staticClass: "booking-widget__input",
                          attrs: {
                            id: "check-out",
                            name: "end_date",
                            type: "text",
                            title: "End Date",
                            placeholder: _vm.chooseDatePlaceholder,
                            readonly: !props.isTypeable
                          },
                          domProps: {
                            value: props.endDate
                              ? _vm
                                  .moment(props.endDate, "DD/MM/YYYY")
                                  .format("DD-MM-YYYY")
                              : null
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "theme-input__extra-info" }, [
                          _c("span", { staticClass: "icon-calendar" })
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          attrs: { type: "hidden", name: "end_date" },
                          domProps: {
                            value: _vm
                              .moment(props.endDate, "DD/MM/YYYY")
                              .format("YYYY-MM-DD")
                          }
                        })
                      ]
                    )
                  ])
                ])
              ]
            }
          }
        ]),
        model: {
          value: _vm.model,
          callback: function($$v) {
            _vm.model = $$v
          },
          expression: "model"
        }
      }),
      _vm._v(" "),
      _c("theme-multiple-files", {
        ref: "themeFileInput",
        attrs: {
          accept: "application/pdf, image/*",
          name: "document[]",
          id: _vm.id,
          white: true
        }
      }),
      _vm._v(" "),
      _vm.showLoader
        ? _c("div", { staticClass: "progress" }, [
            _c("div", { staticClass: "progress-bar" })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.model &&
      _vm.model.dateRange &&
      _vm.model.dateRange.start &&
      _vm.model.dateRange.end
        ? [
            _c(
              "div",
              { staticClass: "booking-widget__summary-list" },
              [
                _c("p", {}, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm
                          .moment(_vm.model.dateRange.end, "DD/MM/YYYY")
                          .diff(
                            _vm.moment(_vm.model.dateRange.start, "DD/MM/YYYY"),
                            "days"
                          ) + 1
                      ) +
                      "\n        " +
                      _vm._s(
                        _vm.locales &&
                          _vm.locales.common &&
                          _vm.locales.common.days
                      ) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "booking-widget__summary-item" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.locales &&
                          _vm.locales.properties &&
                          _vm.locales.properties.price
                      ) + ":"
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "booking-widget__summary-price" }, [
                    _vm._v("€ " + _vm._s(_vm.bookPrice.toFixed(2)))
                  ])
                ]),
                _vm._v(" "),
                _vm._l(_vm.extraPrices, function(item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "booking-widget__summary-item" },
                    [
                      _c("span", [_vm._v(_vm._s(item.name) + ":")]),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "booking-widget__summary-price" },
                        [
                          _vm._v(
                            "€ " +
                              _vm._s(
                                _vm
                                  .getPeriodPrice(item.price, "month")
                                  .toFixed(2)
                              )
                          )
                        ]
                      )
                    ]
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "booking-widget__summary-item" }, [
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.locales &&
                          _vm.locales.common &&
                          _vm.locales.common.total
                      ) + ":"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "strong",
                    { staticClass: "booking-widget__summary-price" },
                    [_vm._v("€ " + _vm._s(_vm.total.toFixed(2)))]
                  )
                ])
              ],
              2
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isLogged
        ? _c(
            "button",
            {
              staticClass: "theme-btn theme-btn--block theme-btn--primary",
              attrs: { "data-type": "submitBtn" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.submitForm.apply(null, arguments)
                }
              }
            },
            [_vm._v(_vm._s(_vm.buttonName))]
          )
        : _c(
            "a",
            {
              staticClass: "theme-btn theme-btn--block theme-btn--primary",
              attrs: { "data-feature": "open-modal", "data-target": "login" }
            },
            [_vm._v("\n      " + _vm._s(_vm.buttonName) + "\n  ")]
          )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c5fbd22", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c5fbd22","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/BookingWidget.vue
// module id = 703
// module chunks = 1